import UIHelper from 'general/helpers/UIHelper';
import useRouter from 'hooks/useRouter';
import MaintainerChargeStationDetailView from '../../components/MaintainerChargeStationDetailView';

MaintainerChargeStationDetailScreen.propTypes = {};

function MaintainerChargeStationDetailScreen(props) {
  // MARK: ---- PROPERTIES ----
  const router = useRouter();
  const chargeStationId = router.query?.chargeStationId;

  return (
    <div>
      {/* breadcrumb */}
      <div>
        {UIHelper.buildBreadcrumb([
          {
            title: 'Danh sách trạm sạc',
            onPress: () => {
              router.navigate(-1);
            },
          },
          { title: 'Chi tiết trạm sạc' },
        ])}
      </div>
      <div className="my-4">
        <MaintainerChargeStationDetailView chargeStationId={chargeStationId} />
      </div>
    </div>
  );
}

export default MaintainerChargeStationDetailScreen;
